import classNames from "classnames";
import React, { useContext } from "react";
import { RicosNodeContext } from "./../../ricos-context/index.js";
import { COLLAPSIBLE_LIST_ITEM_BODY, COLLAPSIBLE_LIST_ITEM_TITLE } from "../data-hooks.js";
import classes from "../statics/styles/collapsible-list-pair-scss.js";
import { getAlignmentFromDirection } from "../utils.js";
import { CollapsibleListContext } from "./collapsible-list-context.js";
const CollapsibleListItemProperty = ({
  node,
  RicosNodesRenderer,
  type
}) => {
  const { parentNode: rootNode } = useContext(RicosNodeContext);
  const { toggle } = useContext(CollapsibleListContext);
  const rootNodeDirection = rootNode?.collapsibleListData?.direction;
  const listAlignment = rootNodeDirection ? getAlignmentFromDirection(rootNodeDirection) : void 0;
  const handleClick = () => {
    if (type === "title" && rootNode) {
      const parentItem = findParent(node.id, rootNode);
      if (parentItem) {
        toggle(parentItem.id);
      }
    }
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(classes.container, classes.viewerContainer, classes.innerEditor, {
        [classes.titleContainer]: type === "title"
      }),
      onClick: handleClick,
      "data-hook": type === "title" ? COLLAPSIBLE_LIST_ITEM_TITLE : COLLAPSIBLE_LIST_ITEM_BODY
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        style: {
          width: "100%",
          textAlign: listAlignment
        }
      },
      /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes ?? [], shouldParagraphApplyTextStyle: true })
    )
  );
};
const findParent = (childId, potentialParent) => {
  if (potentialParent.nodes?.some((n) => n.id === childId)) {
    return potentialParent;
  }
  return potentialParent.nodes?.map((n) => findParent(childId, n)).find((n) => n !== void 0);
};
const CollapsibleListItemTitleProperty = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(CollapsibleListItemProperty, { key: node.id, node, ...props, type: "title" });
};
const CollapsibleListItemBodyProperty = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(CollapsibleListItemProperty, { key: node.id, node, ...props, type: "body" });
};
var collapsible_item_property_default = CollapsibleListItemProperty;
export {
  CollapsibleListItemBodyProperty,
  CollapsibleListItemTitleProperty,
  collapsible_item_property_default as default
};
//# sourceMappingURL=collapsible-item-property.js.map
